import React, { useEffect, useState } from "react";
import Select from "react-select";

export function ItemsPerPage({ searchResultLength, setDataItemsPerPage }) {
  // ******************************************************************************
  // Items Per Page start
  const dataItemsPerPage = [
    {
      id: 1,
      value: 10,
      label: "10",
    },
    {
      id: 2,
      value: 25,
      label: "25",
    },
    {
      id: 3,
      value: 50,
      label: "50",
    },
    {
      id: 4,
      value: 100,
      label: "100",
    },
    {
      id: 5,
      value: 500,
      label: "500",
    },
    {
      id: 6,
      value: "all",
      label: `All ${searchResultLength}`,
    },
  ];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const handleSetItemsPerPage = (e) => {
    if (e?.value === "all") {
      setItemsPerPage(searchResultLength);
    } else {
      setItemsPerPage(e.value);
    }
  };
  useEffect(() => {
    setDataItemsPerPage(itemsPerPage);
  }, [itemsPerPage]);

  const localAuthUser = +JSON.parse(localStorage.getItem("authUser"))
    ?.get_configitem_data?.ZCONFIGVAL_28_X;

  useEffect(() => {
    if (localAuthUser) {
      setItemsPerPage(localAuthUser);
    }
  }, []);
  // Items Per page finish
  // ******************************************************************************
  return (
    <>
      <Select
        placeholder={`${itemsPerPage} per page`}
        value={itemsPerPage}
        onChange={(e) => handleSetItemsPerPage(e)}
        options={dataItemsPerPage}
        id="items-per-page-select"
      ></Select>
    </>
  );
}
